module.exports = __webpack_public_path__ + "img/14.299c5e26.png";